import { useEffect, useState } from "react";

import { api } from "../../api/client";
import { AdminPageIntro } from "../../components/admin/AdminPageIntro";
import { AlertBanner } from "../../components/feedback/AlertBanner";
import { FormModal } from "../../components/modals/FormModal";
import { apiError } from "../../lib/apiError";

type MaintenanceMode = {
  enabled: boolean;
  message: string;
};

export function AdminToolsPage() {
  const [maintenance, setMaintenance] = useState<MaintenanceMode | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [seedOpen, setSeedOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  async function loadMaintenance() {
    const result = await api.GET("/api/platform/maintenance");
    if (result.error) {
      setError(apiError(result.error, "Nie udało się wczytać statusu konserwacji."));
      return;
    }
    setMaintenance(result.data as MaintenanceMode);
  }

  useEffect(() => {
    void loadMaintenance();
  }, []);

  async function seedDemo() {
    setBusy(true);
    setError(null);
    setSuccess(null);

    const result = await api.POST("/api/platform/seed-demo");
    setBusy(false);
    setSeedOpen(false);

    if (result.error) {
      setError(apiError(result.error, "Nie udało się zresetować konta demo."));
      return;
    }

    const data = result.data as { message?: string };
    setSuccess(data.message ?? "Konto demo zostało zresetowane.");
  }

  return (
    <div className="page__content page__content--admin">
      <AdminPageIntro>Operacje administracyjne platformy.</AdminPageIntro>

      {error ? (
        <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
      ) : null}
      {success ? (
        <AlertBanner variant="ok" message={success} onDismiss={() => setSuccess(null)} />
      ) : null}

      <section className="admin-tool-card">
        <h3>Tryb konserwacji</h3>
        <p className="muted">
          Status odczytywany ze zmiennej środowiskowej. Zmiana wymaga restartu aplikacji.
        </p>
        {maintenance ? (
          <AlertBanner
            variant={maintenance.enabled ? "warn" : "ok"}
            message={maintenance.message}
          />
        ) : (
          <p className="muted">Ładowanie…</p>
        )}
      </section>

      <section className="admin-tool-card">
        <h3>Konto demonstracyjne</h3>
        <p className="muted">
          Resetuje konto marketingowe z przykładowymi danymi. Wymaga ALLOW_MARKETING_SEED=true.
        </p>
        <button
          type="button"
          className="btn"
          onClick={() => setSeedOpen(true)}
        >
          Resetuj konto demo
        </button>
      </section>

      <FormModal
        open={seedOpen}
        onClose={() => setSeedOpen(false)}
        title="Reset konta demo"
        testId="admin-seed-demo-modal"
      >
        <p>
          Ta operacja nadpisze dane konta demonstracyjnego. Kontynuować?
        </p>
        <div className="modal__actions">
          <button
            type="button"
            className="btn btn--ghost"
            onClick={() => setSeedOpen(false)}
            disabled={busy}
          >
            Anuluj
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => void seedDemo()}
            disabled={busy}
          >
            {busy ? "Resetowanie…" : "Resetuj"}
          </button>
        </div>
      </FormModal>
    </div>
  );
}
